import { FC } from 'react'

import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { FullScreenModal } from 'src/Components/FullScreenModal'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { useSpotifyCampaignStatus } from 'src/Redux/spotifyCampaignStatusApi'

import { TrackFileModalContent } from './TrackFileModalContent'
import { useTrackFileUpload } from './useTrackFileUpload'

const StyledModal = styled(FullScreenModal)`
  height: 100%;
`

export const TrackFileModal: FC = () => {
  const { number: campaignId } = useParams<{ number: string }>()
  const { trackFile } = useSpotifyCampaignStatus()
  const { setSearch } = useCustomSearchParams()

  const handleClose = (): void => {
    setSearch({ modal: null })
  }

  const {
    file,
    status,
    progress,
    error,
    isSaving,
    canSave,
    selectFile,
    removeFile,
    saveFile,
  } = useTrackFileUpload({
    campaignId: campaignId || '',
    savedFile: trackFile,
    onSaved: handleClose,
  })

  return (
    <StyledModal
      showCloseButton
      onCancel={handleClose}
      prefixCls='trackFile'
      open
    >
      <TrackFileModalContent
        file={file}
        status={status}
        progress={progress}
        error={error}
        isSaving={isSaving}
        canSave={canSave}
        onFileSelect={selectFile}
        onRemove={removeFile}
        onSave={saveFile}
        onClose={handleClose}
      />
    </StyledModal>
  )
}
